import React from 'react';
import Box from '@mui/material/Box';

import { styles } from '../WorkingHours.styles';

const labels = Array.from({ length: 9 }, (_, i) => `${String(i * 3).padStart(2, '0')}:00`);

const HoursAxis = () => {
  return (
    <Box sx={styles.hoursAxis}>
      {labels.map(label => (
        <Box key={label} sx={styles.hoursAxisLabel}>
          {label}
        </Box>
      ))}
    </Box>
  );
};

export default HoursAxis;
